import { Avatar, Button, Card, Stack, Typography } from "@mui/material"
import { CardInfo, StackButtons, TypStatictic } from "./style"
import { NavLink, useNavigate } from "react-router-dom"
import { routesProfile } from "../../../consts"
import { GrowthToolInfoProps } from "../../../types/entitys/growthTool"
import { formatNumber } from "../../../common/FormatNumber"
import { formatApiDateToDdMmYyyy } from "../../../utils/common"
import { GrowthToolLikeControl } from "../GrowthToolLikeControl"
import { useGrowthToolEngagement } from "../../../hooks/useGrowthToolEngagement"
import {
    canNavigateToUserProfile,
    getUserInitialsFromDisplayName,
    resolveUserAvatarUrl,
    resolveUserDisplayName,
} from "../../../utils/deletedUserDisplay"

export const GrowthToolInfo = ({ growthTool }: GrowthToolInfoProps) => {
    const navigate = useNavigate()
    const authorName = resolveUserDisplayName(growthTool.author)
    const cacheKey = growthTool.slug || growthTool.id
    const {
        isAuthor,
        isFavorite,
        favoritesCount,
        isLiked,
        likesCount,
        toggleFavorite,
        toggleLike,
        isFavoriteLoading,
        isLikeLoading,
    } = useGrowthToolEngagement({ growthTool, cacheKey })

    const handleOpenAuthor = () => {
        if (!canNavigateToUserProfile(growthTool.author)) return
        navigate(`/${routesProfile.USERS.path}/${growthTool.author?.slug}`)
    }

    return (
        <Card variant="primaryAdaptiveCard" sx={CardInfo}>
            <Stack direction="column" gap={{ xs: 1, sm: 2 }}>
                <Typography variant="h3">Статистика инструмента</Typography>

                <Stack
                    direction="row"
                    gap={1}
                    alignItems="center"
                    onClick={handleOpenAuthor}
                    sx={{ cursor: canNavigateToUserProfile(growthTool.author) ? "pointer" : "default" }}
                >
                    <Avatar src={resolveUserAvatarUrl(growthTool.author)} sx={{ width: 32, height: 32 }}>
                        {getUserInitialsFromDisplayName(authorName)}
                    </Avatar>
                    <Typography variant="black-14-medium" noWrap>{authorName}</Typography>
                </Stack>

                <Stack direction="column" gap={0.5}>
                    <Typography variant="black-14-light" sx={{ lineHeight: "18px" }}>Создан: {formatApiDateToDdMmYyyy(growthTool.created_at)}</Typography>
                    <Typography variant="black-14-light" sx={{ lineHeight: "18px" }}>Отредактирован: {formatApiDateToDdMmYyyy(growthTool.updated_at)}</Typography>
                </Stack>

                <Stack direction="column" gap={0.5}>
                    <Typography variant="h4" sx={TypStatictic}>В избранном: {formatNumber(favoritesCount)}</Typography>
                    <Typography variant="h4" sx={TypStatictic}>Просмотров: {formatNumber(growthTool.counters.views)}</Typography>
                </Stack>

                <Stack direction="column" gap={1.5} alignItems="flex-start" sx={StackButtons}>
                    {isAuthor ? (
                        <Button variant="follow" component={NavLink} to={`/${routesProfile.GROWTHTOOLS.path}/${growthTool.id}/edit`}>
                            Редактировать
                        </Button>
                    ) : (
                        <Button
                            variant="follow"
                            disabled={isFavoriteLoading}
                            onClick={() => void toggleFavorite()}
                        >
                            {isFavorite ? "В избранном" : "В избранное"}
                        </Button>
                    )}
                    <GrowthToolLikeControl
                        growthToolId={growthTool.id}
                        isLiked={isLiked}
                        likesCount={likesCount}
                        likesPreview={growthTool.likes_preview}
                        onToggleLike={toggleLike}
                        loading={isLikeLoading}
                    />
                </Stack>     
            </Stack>
        </Card>
    )
}
